import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem, ListItemIcon } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { NotificationsNone } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import "./index.scss";
import logo from "../../resources/images/logo.png";
import { clearOfflineData, getOfflineData } from "../../utils/offline-services";
import SideMenu from "../side-menu";
import Badge from "@mui/material/Badge";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { CF_APPROVAL_COMMON_ROUTE } from "../../../common-utilities/utils/end-points/cf-approval";
import { HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/cf-approval";
import { redirectToIntranetPortal } from "../../utils/common-utils";
import { INTRANETHOSTNAME } from "../../../common-utilities/utils/end-points";
import Intranetlogout from "../../../../core/header/logout";
import { tokenMainKeys } from "../../../../utils/constants";
import Logout from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Header = ({ reloadPendingApprovals, setReloadPendingApprovals }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userDetails, setUserDetails] = useState({});
  const [unapprovedFormsCount, setunapprovedFormsCount] = useState(0);
  const loadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.UNAPPROVED_FORMS}`,
      null,
      { page: 1, limit: 10, sortBy: "-createdAt" }
    )
      .then((response) => {
        const count = response?.totalResults || 0;
        setunapprovedFormsCount(count);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (reloadPendingApprovals) {
      setReloadPendingApprovals(false);
      loadData();
    }
  }, [reloadPendingApprovals]);

  useEffect(() => {
    let user = getOfflineData("user");
    setUserDetails(user);
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    clearOfflineData(tokenMainKeys.cfApproval, "user");
    clearOfflineData(tokenMainKeys.cfApproval, "tokens");
    Intranetlogout(navigate);
  };
  return (
    <div className="header-container">
      <div className="logo-con">
        <SideMenu />
      </div>
      <div className="endLoginContainer">
        <Badge
          className="notification-icon"
          badgeContent={`${unapprovedFormsCount}`}
          color="primary"
        >
          <NotificationsNone
            onClick={() => navigate(`${CF_APPROVAL_COMMON_ROUTE}/approval`)}
            className="main-notification-icon"
          />
        </Badge>

        <div className="menu">
          <Avatar className="si-hide-mobile">
            <AccountCircleIcon />
          </Avatar>
          <Button
            type="small"
            variant="text"
            onClick={(event) => setAnchorEl(event.currentTarget)}
            endIcon={<KeyboardArrowDownIcon />}
          >
            {userDetails.name}
          </Button>

          <Menu
            anchorEl={anchorEl}
            open={!!anchorEl}
            onClose={handleClose}
            onClick={handleClose}
          >
            <MenuItem onClick={logout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Header;
